import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { ModalFormsContext } from 'components/modals'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { startConfirmUserEmail } from 'redux/user/user-actions'
import { getRefreshToken } from 'utils/accessHelpers'

import { COMPONENT_EXTENDER } from 'extender'

const SkeletonAccounts = COMPONENT_EXTENDER('components/core/Skeleton/SkeletonAccounts/SkeletonAccounts-component')

const ConfirmEmail = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const { modalValues } = useContext(ModalFormsContext)
    const dispatch = useAppDispatch()

    const { userEmailStatus } = useAppSelector(state => state.user)

    useEffect(() => {
        const guid = new URLSearchParams(location?.search).get('guid')

        !!guid && dispatch(startConfirmUserEmail({ guid }))
    }, [])

    useEffect(() => {
        if (userEmailStatus === 'success') {
            modalValues.handleModalOpen({
                modal: 'EmailConfirmationModal',
                text: t('ConfirmEmail.EmailConfirmedSuccessfully'),
                type: 'success',
            })
            navigate(`${getRefreshToken() ? '/' : '/sign-in'}`)
        }
        if (userEmailStatus === 'failure') {
            modalValues.handleModalOpen({
                modal: 'EmailConfirmationModal',
                type: 'failure',
                text: t('ConfirmEmail.PleaseTryAgain'),
            })
            navigate(`${getRefreshToken() ? '/success' : '/sign-in'}`)
        }
    }, [navigate, userEmailStatus])

    return <SkeletonAccounts />
}

export default ConfirmEmail
